import Vue from 'vue';
const FALLBACK = require('@/assets/image_not_found.png');
const DEFAULT_LOGO = require('@/assets/logo_earcon.gif');

export function resolve_logo(url, failed) {
  if (failed) {
    return FALLBACK;
  }

  let logo = null;

  if (!url) {
    logo = DEFAULT_LOGO;

  } else {
    logo = url;
    if (logo.indexOf('//') <= 2) {
      logo = Vue.prototype.$base + '/' + logo;
    }
  }

  return logo;
}

export function resolve_image(url) {
  let image = null;

  if (url) {
    image = url;
    if (image.indexOf('//') <= 2) {
      image = Vue.prototype.$base + '/' + image;
    }
  }

  return image;
}